import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { Link } from "react-router-dom";
import {
  ArrowLeft,
  BookOpen,
  Search,
  Filter,
  X,
  Globe,
  Lock,
  Loader2,
  FileText,
  PlayCircle,
  Layers, // Ikon untuk Kelas
} from "lucide-react";

export default function MateriBelajar() {
  const [listMateri, setListMateri] = useState([]);
  const [listMapel, setListMapel] = useState([]);
  const [loading, setLoading] = useState(true);

  // STATE FILTER
  const [filterMapel, setFilterMapel] = useState("");
  const [filterJenis, setFilterJenis] = useState("");
  const [filterAkses, setFilterAkses] = useState("");
  const [filterKelas, setFilterKelas] = useState(""); // Filter Kelas Baru
  const [searchJudul, setSearchJudul] = useState("");

  const [previewUrl, setPreviewUrl] = useState(null);

  // Opsi Kelas untuk Filter
  const opsiKelas = [
    "TK",
    "1 SD",
    "2 SD",
    "3 SD",
    "4 SD",
    "5 SD",
    "6 SD",
    "7 SMP",
    "8 SMP",
    "9 SMP",
    "10 SMA",
    "11 SMA",
    "12 SMA",
    "Umum",
  ];

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    setLoading(true);
    try {
      // 1. Ambil Data Mapel
      const { data: dataMapel } = await supabase
        .from("mata_pelajaran")
        .select("*")
        .order("nama_mapel", { ascending: true });
      setListMapel(dataMapel || []);

      // 2. Ambil Semua Materi
      // Pastikan kolom 'kelas' juga terambil
      const { data: dataMateri, error } = await supabase
        .from("materi")
        .select("*")
        .order("urutan", { ascending: true })
        .order("created_at", { ascending: false });

      if (error) throw error;
      setListMateri(dataMateri || []);
    } catch (err) {
      console.error("Gagal memuat data:", err);
    } finally {
      setLoading(false);
    }
  }

  // --- LOGIKA FILTERING ---
  const filteredMateri = listMateri.filter((item) => {
    const matchJudul = item.judul
      .toLowerCase()
      .includes(searchJudul.toLowerCase());
    const matchMapel = filterMapel ? item.mata_pelajaran === filterMapel : true;
    const matchJenis = filterJenis
      ? (item.jenis || "Materi") === filterJenis
      : true;

    // Filter Kelas
    const itemKelas = item.kelas || "Umum"; // Default Umum jika kosong
    const matchKelas = filterKelas ? itemKelas === filterKelas : true;

    // Filter Akses
    let matchAkses = true;
    if (filterAkses === "Gratis") matchAkses = item.is_public === true;
    if (filterAkses === "Premium") matchAkses = item.is_public === false;

    return matchJudul && matchMapel && matchJenis && matchAkses && matchKelas;
  });

  // --- LOGIKA BUKA MATERI ---
  const handleBukaMateri = (item) => {
    if (item.link_url) {
      setPreviewUrl(item.link_url);
    } else {
      alert("Link materi ini belum tersedia.");
    }
  };

  const resetFilter = () => {
    setFilterMapel("");
    setFilterJenis("");
    setFilterAkses("");
    setFilterKelas("");
    setSearchJudul("");
  };

  if (loading)
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          background: "#f8fafc",
        }}
      >
        <Loader2 className="animate-spin" size={40} color="#2563eb" />
        <p style={{ marginTop: 15, color: "#64748b" }}>
          Memuat Materi Belajar...
        </p>
      </div>
    );

  return (
    <div
      style={{
        maxWidth: "600px",
        margin: "0 auto",
        padding: "20px",
        fontFamily: "sans-serif",
        background: "#f8fafc",
        minHeight: "100vh",
      }}
    >
      {/* HEADER */}
      <Link
        to="/"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
          textDecoration: "none",
          color: "#64748b",
          marginBottom: "20px",
        }}
      >
        <ArrowLeft size={18} /> Kembali ke Dashboard
      </Link>

      <div style={{ marginBottom: "25px" }}>
        <h2 style={{ margin: "0 0 5px 0", color: "#1e293b", fontSize: "24px" }}>
          Materi Belajar
        </h2>
        <p style={{ margin: 0, color: "#64748b", fontSize: "14px" }}>
          Akses penuh ke semua materi & latihan soal.
        </p>
      </div>

      {/* --- AREA FILTER & PENCARIAN --- */}
      <div
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "16px",
          boxShadow: "0 4px 6px rgba(0,0,0,0.02)",
          border: "1px solid #e2e8f0",
          marginBottom: "20px",
        }}
      >
        {/* Search Bar */}
        <div style={{ position: "relative", marginBottom: "15px" }}>
          <Search
            size={18}
            color="#94a3b8"
            style={{ position: "absolute", left: 12, top: 12 }}
          />
          <input
            style={{
              width: "100%",
              padding: "12px 12px 12px 40px",
              borderRadius: "10px",
              border: "1px solid #cbd5e1",
              outline: "none",
              boxSizing: "border-box",
            }}
            placeholder="Cari judul materi..."
            value={searchJudul}
            onChange={(e) => setSearchJudul(e.target.value)}
          />
        </div>

        {/* Filter Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "10px",
            marginBottom: "10px",
          }}
        >
          {/* FILTER KELAS (BARU) */}
          <select
            style={{
              padding: "10px",
              borderRadius: "8px",
              border: "1px solid #cbd5e1",
              outline: "none",
              background: "white",
              color: "#334155",
              fontSize: "13px",
              fontWeight: "bold",
            }}
            value={filterKelas}
            onChange={(e) => setFilterKelas(e.target.value)}
          >
            <option value="">Semua Tingkat</option>
            {opsiKelas.map((k) => (
              <option key={k} value={k}>
                {k}
              </option>
            ))}
          </select>

          <select
            style={{
              padding: "10px",
              borderRadius: "8px",
              border: "1px solid #cbd5e1",
              outline: "none",
              background: "white",
              color: "#334155",
              fontSize: "13px",
            }}
            value={filterMapel}
            onChange={(e) => setFilterMapel(e.target.value)}
          >
            <option value="">Semua Mapel</option>
            {listMapel.map((m) => (
              <option key={m.id} value={m.nama_mapel}>
                {m.nama_mapel}
              </option>
            ))}
          </select>

          <select
            style={{
              padding: "10px",
              borderRadius: "8px",
              border: "1px solid #cbd5e1",
              outline: "none",
              background: "white",
              color: "#334155",
              fontSize: "13px",
            }}
            value={filterJenis}
            onChange={(e) => setFilterJenis(e.target.value)}
          >
            <option value="">Semua Tipe</option>
            <option value="Materi">📖 Materi</option>
            <option value="Latihan">📝 Latihan</option>
          </select>

          <select
            style={{
              padding: "10px",
              borderRadius: "8px",
              border: "1px solid #cbd5e1",
              outline: "none",
              background: "white",
              color: "#334155",
              fontSize: "13px",
            }}
            value={filterAkses}
            onChange={(e) => setFilterAkses(e.target.value)}
          >
            <option value="">Semua Status</option>
            <option value="Gratis">🌍 Gratis</option>
            <option value="Premium">🔒 Premium</option>
          </select>
        </div>

        <button
          onClick={resetFilter}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #e2e8f0",
            background: "#f1f5f9",
            color: "#475569",
            cursor: "pointer",
            fontSize: "13px",
            fontWeight: "600",
          }}
        >
          Reset Semua Filter
        </button>
      </div>

      {/* --- HASIL LIST MATERI --- */}
      <div style={{ marginBottom: 15, fontSize: 13, color: "#64748b" }}>
        Menampilkan <strong>{filteredMateri.length}</strong> materi
      </div>

      {filteredMateri.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            background: "white",
            borderRadius: "12px",
            border: "1px dashed #cbd5e1",
          }}
        >
          <Filter size={40} color="#cbd5e1" style={{ marginBottom: 10 }} />
          <p style={{ color: "#94a3b8" }}>Tidak ada materi yang cocok.</p>
          <button
            onClick={resetFilter}
            style={{
              marginTop: 10,
              color: "#2563eb",
              background: "none",
              border: "none",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            Hapus Filter
          </button>
        </div>
      ) : (
        <div style={{ display: "grid", gap: "12px" }}>
          {filteredMateri.map((item) => {
            const isPremium = item.is_public === false;
            const jenis = item.jenis || "Materi";
            const kelasLabel = item.kelas || "Umum";

            return (
              <div
                key={item.id}
                style={{
                  background: "white",
                  padding: "16px",
                  borderRadius: "16px",
                  marginBottom: "0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                  border: "1px solid #f1f5f9",
                }}
              >
                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      marginBottom: "6px",
                      flexWrap: "wrap",
                    }}
                  >
                    {/* Badge KELAS (BARU) */}
                    <span
                      style={{
                        fontSize: "11px",
                        fontWeight: "bold",
                        padding: "2px 8px",
                        borderRadius: "10px",
                        background: "#f3e8ff",
                        color: "#7e22ce",
                        display: "flex",
                        alignItems: "center",
                        gap: 3,
                      }}
                    >
                      <Layers size={10} /> {kelasLabel}
                    </span>

                    {/* Badge Mapel */}
                    <span
                      style={{
                        fontSize: "11px",
                        fontWeight: "bold",
                        padding: "2px 8px",
                        borderRadius: "10px",
                        background: "#f1f5f9",
                        color: "#64748b",
                      }}
                    >
                      {item.mata_pelajaran || "Umum"}
                    </span>

                    {/* Badge Premium */}
                    <span
                      style={{
                        fontSize: "11px",
                        fontWeight: "bold",
                        padding: "2px 8px",
                        borderRadius: "10px",
                        background: isPremium ? "#fff7ed" : "#f0fdf4",
                        color: isPremium ? "#b45309" : "#166534",
                        display: "flex",
                        alignItems: "center",
                        gap: 3,
                      }}
                    >
                      {isPremium ? <Lock size={10} /> : <Globe size={10} />}
                      {isPremium ? "Premium" : "Gratis"}
                    </span>
                  </div>

                  <div
                    style={{
                      fontWeight: "700",
                      fontSize: "15px",
                      color: "#1e293b",
                      marginBottom: "2px",
                    }}
                  >
                    {item.judul}
                  </div>

                  <div
                    style={{
                      fontSize: "12px",
                      color: "#64748b",
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                    }}
                  >
                    {jenis === "Latihan" ? (
                      <FileText size={12} />
                    ) : (
                      <BookOpen size={12} />
                    )}
                    {jenis}
                  </div>
                </div>

                {/* TOMBOL BUKA */}
                <button
                  onClick={() => handleBukaMateri(item)}
                  style={{
                    background: "#e0f2fe",
                    color: "#0284c7",
                    border: "none",
                    padding: "10px 16px",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    cursor: "pointer",
                    fontWeight: "700",
                    fontSize: "13px",
                  }}
                >
                  {jenis === "Latihan" ? "Kerjakan" : "Buka"}
                </button>
              </div>
            );
          })}
        </div>
      )}

      {/* PREVIEW FRAME */}
      {previewUrl && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(15, 23, 42, 0.9)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button
            onClick={() => setPreviewUrl(null)}
            style={{
              position: "absolute",
              top: 20,
              right: 20,
              background: "white",
              border: "none",
              borderRadius: "50%",
              width: 40,
              height: 40,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <X size={24} color="#333" />
          </button>
          <div
            style={{
              width: "90%",
              maxWidth: "900px",
              height: "85vh",
              background: "white",
              borderRadius: "16px",
              overflow: "hidden",
            }}
          >
            <iframe
              src={previewUrl}
              title="Materi"
              width="100%"
              height="100%"
              style={{ border: "none" }}
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
}
